type SlotForToday = {
  id: number;
  start_time: string;
  end_time: string;
  max_participants: number;
  places_left: number;
  /** Отменённое занятие показываем с подписью, но не считаем в «занятиях сегодня». */
  status?: 'active' | 'cancelled';
};

type BookingForPayment = {
  status: string;
  service_payment_required: boolean;
  payment_received: boolean;
};

export type TodaySlotsSummary<T extends SlotForToday> = {
  total: number;
  /** Занято мест во всех занятиях дня. */
  taken: number;
  capacity: number;
  /** До трёх ближайших занятий, которые ещё не закончились. */
  upcoming: T[];
};

/** Текущее время ЧЧ:ММ в часовом поясе организации. */
export function nowHmInTimezone(now: Date, timezone: string | null | undefined): string {
  try {
    return now.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: timezone || undefined });
  } catch {
    return now.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', hour12: false });
  }
}

export function summarizeTodaySlots<T extends SlotForToday>(
  slots: readonly T[],
  now: Date,
  timezone: string | null | undefined
): TodaySlotsSummary<T> {
  const nowHm = nowHmInTimezone(now, timezone);
  const activeSlots = slots.filter((s) => s.status !== 'cancelled');
  let taken = 0;
  let capacity = 0;
  for (const s of activeSlots) {
    capacity += Math.max(0, s.max_participants);
    taken += Math.max(0, s.max_participants - s.places_left);
  }
  const upcoming = [...slots]
    .filter((s) => s.end_time.slice(0, 5) > nowHm)
    .sort((a, b) => a.start_time.localeCompare(b.start_time))
    .slice(0, 3);
  return { total: activeSlots.length, taken, capacity, upcoming };
}

/** Запись ждёт оплаты: оплата нужна и ещё не получена (онлайн или наличными в студии). */
export function isUnpaidBooking(b: BookingForPayment): boolean {
  if (b.status === 'pending_payment' || b.status === 'cash_waiting') return true;
  return b.service_payment_required && !b.payment_received;
}
